const RUN_MODES = {
  DEBUG: "DEBUG",
  PRODUCTION: "PRODUCTION",
};
const runMode = RUN_MODES.PRODUCTION;

let endpoint;
switch (runMode) {
  case RUN_MODES.DEBUG:
    endpoint = "https://api-dev-khunamoon.zharfabeen.com";
    break;
  case RUN_MODES.PRODUCTION:
    endpoint = "https://api-khunamoon.zharfabeen.com";
    break;
  default:
    endpoint = "https://api-khunamoon.zharfabeen.com";
}

endpoint = process.env.REACT_APP_API_ENDPOINT || endpoint;

const FILE_SERVER_ENDPOINT =
  process.env.REACT_APP_FILE_SERVER_ENDPOINT || "https://fs.zharfabeen.com";
const USER_PROFILE_PIC_URL_TEMPLATE = `${FILE_SERVER_ENDPOINT}/familyId/memberId.jpg?d=random`;
module.exports = {
  RUN_MODES,
  runMode,
  endpoint,
  FILE_SERVER_ENDPOINT,
  USER_PROFILE_PIC_URL_TEMPLATE,
};
